import Box from '@material-ui/core/Box';
import React, {Component} from 'react';
import { withRouter } from 'react-router';
import { withUser } from '../../../utils/ReactWrappers';

import ReminderList from '../../lists/ReminderList';
import Loader from '../../widgets/Loader';

class ClientReminders extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
        const {isLoading} = this.state;

		if(isLoading) {
            return <Loader />;
        }

        return (
			<Box>
                {this.renderReminders()}
            </Box>
		);
	}

    renderReminders() {
        const {client} = this.props;

        return <ReminderList clientId={client._id} />;
    }
}

export default withRouter(withUser(ClientReminders));
